<template>
  <vue-plotly v-if="chartData" :data="chartData" class="chart" />
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";
export default {
  name: "OZGActivityHeatmap",
  props: [
    "statusType",
    "statusId",
    "serviceId",
    "categoryId",
    "leadingInstitutionID",
    "applicableLaws",
    "showLegend",
    "referenceImplementation"
  ],
  data() {
    var showlegend = true;
    if (this.$props.showLegend) {
      showlegend = this.$props.showLegend;
    }
    return {
      aggregateOzgTimeline: null,
      showlegend: showlegend,

      chartData: {
        x: ["2017", "2018", "2019", "2020", "2021", "2022"],
        y: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ],
        z: [],
        type: "heatmap"
      },
      chartOptions: {
        sort: false
      }
    };
  },

  watch: {
    aggregateOzgTimeline: function(newVal) {
      var aggregation = {
        y: ["2017", "2018", "2019", "2020", "2021", "2022"],
        x: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ],
        z: [],
        colorscale: [
          [0, "rgb(0,68,27)"],
          [0.125, "rgb(0,109,44)"],
          [0.25, "rgb(35,139,69)"],
          [0.375, "rgb(65,171,93)"],
          [0.5, "rgb(116,196,118)"],
          [0.625, "rgb(161,217,155)"],
          [0.8, "rgb(199,233,192)"],
          [0.98, "rgb(229,245,224)"],
          [1, "rgb(255,255,255)"]
        ],
        zmin: 0,
        zmax: 200,
        showscale: this.showlegend,
        reversescale: true,
        hovertemplate:
          "Monat: <b>%{x} %{y}</b> <br>Leistungen: <b>%{z}</b> <extra></extra>",

        type: "heatmap"
      };

      var y = 2017;
      while (y < 2023) {
        aggregation.z[y - 2017] = [];
        var m = 1;
        while (m < 13) {
          aggregation.z[y - 2017][m - 1] = 0;
          m++;
        }
        y++;
      }
      console.log(aggregation);

      for (var x in newVal) {
        // Shows only the explicitly set index of "5", and ignores 0-4
        aggregation.z[newVal[x].year - 2017][newVal[x].month - 1] =
          newVal[x].count;
      }
      this.chartData = [aggregation];
    }
  },
  components: { VuePlotly },

  apollo: {
    $client: "ozgClient",
    aggregateOzgTimeline: {
      query() {
        return require("../../graphql/OZGTimelineMonthStatusUpdate.gql");
      },
      variables: function() {
        return {
          statusId: this.$props.statusId,
          serviceId: this.$props.serviceId,
          categoryId: this.$props.categoryId,
          leadingInstitutionID: this.$props.leadingInstitutionID,
          statusType: this.$props.statusType,
          applicableLaws: this.$props.applicableLaws,
          referenceImplementation: this.$props.referenceImplementation
        };
      }
    }
  }
};
</script>

<style scoped></style>
